<label>
    @if (label(); as label) {
        <app-label [required]="required()">{{ label }}</app-label>
    }
    <div
        [attr.data-size]="currentSize()"
        [attr.data-rounded]="currentRounded()"
        [attr.data-theme]="theme()"
        class="bg-white input-wrapper input-rounded input-padding"
    >
        <div [attr.data-color]="currentColor()" [attr.data-rounded]="currentRounded()" class="input-outline input-rounded"></div>
        <textarea
            [style.height]="height() + 'px'"
            class="w-full input-text-size theme-text"
            [attr.data-theme]="theme()"
            [attr.data-size]="currentSize()"
            [placeholder]="placeholder()"
            [spellcheck]="spellcheck()"
            [autocomplete]="autocomplete()"
            [autofocus]="autofocus()"
            [readOnly]="readonly()"
            [maxLength]="maxlength() || 524288"
            [(ngModel)]="value"
            (focus)="focus.emit($event)"
            (blur)="blur.emit($event)"
        ></textarea>
    </div>
</label>
